<div class="spinner-container" *ngIf="isProcessing">
  <mat-spinner id="send-email-spinner" [mode]="'indeterminate'"
               [diameter]="40"
               [color]="'accent'"></mat-spinner>
</div>
<div class="mb-30">
  <h1>Request document(s)</h1>
  <span>You should receive an email with your requested documents within a few minutes of submitting your email
        address
        below. If you need to access a copy of your records after closing the browser window, you will need to verify
        your identity again. Please note, email is not a secure method of transmitting sensitive personal information
        and by using this service you accept this risk.</span>
</div>
<div class="formParent" id="request-documents-input-form">
  <div class="content">
    <form [formGroup]="sendEmailForm" (ngSubmit)="sendEmail(sendEmailForm)">
      <section id="request-documents-select-documents-container">
        <h3>Select the document(s) you need</h3>
        <mat-checkbox class="icbc-checkbox" color="primary" formControlName="driverfactor"
                      (change)="disableCheckboxErrorMessage()">Driver factor
          report
        </mat-checkbox>
        <li class="select-documents-tooltip">Your driving experience and crash history</li>
        <mat-checkbox class="icbc-checkbox" color="primary" formControlName="personal"
                      (change)="disableCheckboxErrorMessage()">
          Personal driving record
        </mat-checkbox>
        <li class="select-documents-tooltip">
          For getting driver's licences outside of B.C., car share memberships, and school
          volunteering applications
        </li>
        <mat-checkbox class="icbc-checkbox" color="primary" formControlName="commercial"
                      (change)="disableCheckboxErrorMessage()">
          Commercial driving record or (N) print (National SafetyCode abstract)
        </mat-checkbox>
        <li class="select-documents-tooltip">For commercial, taxi, and ride-hailing drivers</li>
        <mat-checkbox class="icbc-checkbox" color="primary" formControlName="residential"
                      (change)="disableCheckboxErrorMessage()">
          Residential address history
        </mat-checkbox>
        <li class="select-documents-tooltip">Your proof of residency (up to 10 years)</li>
        <mat-checkbox class="icbc-checkbox" color="primary" formControlName="claimhistory"
                      (change)="disableCheckboxErrorMessage()">
          Insurance and claims history record
        </mat-checkbox>
        <li class="select-documents-tooltip">For getting auto insurance outside of B.C.</li>
        <div *ngIf="getNoDocumentedSelectedErroMessage()" class="mb-30">
<!--          <mat-error>-->
            <app-alert-urgent [message]="getNoDocumentedSelectedErroMessage()"></app-alert-urgent>
<!--          </mat-error>-->
        </div>
      </section>

      <div class="icbc-input-label-container">
        <label class="text-bold">Years of claims history</label>
      </div>
      <div class="icbc-input-field" id="request-documents-claims-years">
        <mat-form-field class="w-full icbc-select">
          <mat-select class="" [formControl]="claimYearsFormControl" [disableOptionCentering]="true">
            <mat-option *ngFor="let year of years" [value]="year.value">
              {{year.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div id="request-documents-information">
        <app-alert-information
          [message]="'You may send the document(s) to yourself and to another person of your choice.'"></app-alert-information>
      </div>

      <div class="icbc-input-label-container">
        <label class="text-bold">Email</label>
      </div>
      <div class="icbc-input-field">
        <mat-form-field class="w-full">
          <input type="email" matInput [formControl]="emailFormControl">
          <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
            <app-alert-urgent [message]="invalidEmailErrorMessage"></app-alert-urgent>
          </mat-error>
          <mat-error *ngIf="emailFormControl.hasError('required')">
            <app-alert-urgent [message]="emptyEmailErrorMessage"></app-alert-urgent>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="icbc-input-label-container">
        <label class="text-bold">Confirm email</label>
      </div>
      <div class="icbc-input-field">
        <mat-form-field class="w-full">
          <input type="email" matInput [formControl]="confirmEmailFormControl">
          <mat-error *ngIf="sendEmailForm.invalid">
            <app-alert-urgent [message]="getConfirmEmailErrorMessage()"></app-alert-urgent>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="terms-and-conditions-container mb-30">
        <div class="terms-and-conditions-checkbox">
          <mat-checkbox class="icbc-checkbox" color="primary" formControlName="surveyCheckBox">
            I agree to receive ICBC's emails containing surveys
            regarding ICBC and its products. I may withdraw my consent at any time.
          </mat-checkbox>
        </div>
<!--        <div>-->
<!--          I agree to receive ICBC's emails containing surveys-->
<!--          regarding ICBC and its products. I may withdraw my consent at any time.-->
<!--        </div>-->
      </div>

      <div class="icbc-input-label-container">
        <label><span class="text-bold">Email</span>
          (optional)</label>
      </div>
      <div class="icbc-input-field">
        <mat-form-field class="w-full">
          <input type="email" matInput [formControl]="surveyEmailFormControl">
          <mat-error *ngIf="sendEmailForm.invalid">
            <app-alert-urgent [message]="getSurveyEmailErrorMessage()"></app-alert-urgent>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="icbc-input-label-container">
        <label><span class="text-bold">Confirm email</span>
          (optional)</label>
      </div>
      <div class="icbc-input-field">
        <mat-form-field class="w-full">
          <input type="email" matInput [formControl]="confirmSurveyEmailFormControl">
          <mat-error *ngIf="sendEmailForm.invalid">
            <app-alert-urgent [message]="getSurveyConfirmEmailErrorMessage()"></app-alert-urgent>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="mt-50 mb-40">
        <button mat-flat-button type="submit" class="icbc-button" id="request-documents-submit-button">
          Submit
        </button>
      </div>
      <!--debug-->
      <!--            <div class="mt-30 mb-40">-->
      <!--                <button mat-stroked-button color="clio-primary" type="submit">-->
      <!--                    <div class="spinner">-->
      <!--                        <mat-spinner [mode]="'indeterminate'"-->
      <!--                                     [diameter]="'30'"-->
      <!--                                     [color]="'accent'"></mat-spinner>-->
      <!--                    </div>-->
      <!--                </button>-->
      <!--            </div>-->
    </form>
  </div>
</div>

